import React from 'react'
import classes from './style.module.scss'
import PropTypes from 'prop-types'
import { SubstractIcon } from '@Root/assets'

export const InputLabel = ({ style, text, hasAsterisk, clickHandler, onOpenDescription, description, hideHeight }) => {
  return (
    text && (
      <div className={`${classes.InputLabel} ${hideHeight ? '' : classes.height}`} style={style} onClick={clickHandler}>
        {text}
        {hasAsterisk ? '*' : ''}
        {description && (
          <span className={classes.description} onClick={() => onOpenDescription(description, text)}>
            <img src={SubstractIcon} className={classes.mark} />
          </span>
        )}
      </div>
    )
  )
}

InputLabel.propTypes = {
  style: PropTypes.object,
  text: PropTypes.string,
  hasAsterisk: PropTypes.bool,
  clickHandler: PropTypes.func,
}

InputLabel.defaultProps = {
  style: {},
  text: 'Label',
  description: '',
  hasAsterisk: false,
  clickHandler: () => {},
  onOpenDescription: () => {},
}
